import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  OnInit, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { AccountInformationService } from '../../account-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { BrandInfoService } from 'shared/brand/brand-info.service';
import { BrandService } from 'shared/brand/brand.service';
import LanguageCodeMapper from 'utils/language-code-mapper';
import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { BrandFormComponent } from './brand-form.component';
import { PermissionsService } from 'shared/permissions/permissions.service';

import { BRAND_NAME } from '../../variables';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';

@Component({
  moduleId: module.id,
  selector: 'brand-segment',
  template: `
    <brand-form
      [data]='data'
      [segmentData]='segmentData'
      (save)='onSave($event)'
    ></brand-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BrandComponent extends BaseAccountSegmentComponent implements OnInit {
  name: string = BRAND_NAME;
  data: any = undefined;

  @ViewChild(BrandFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: BrandFormComponent | void;

  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
    private brandInfoService: BrandInfoService,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  fetchFormData(): Observable<any> {
    return this.brandInfoService.fetch(this.brandService.getBrand());
  }

  putFormData(): Observable<any> {
    if (!this.formComponent) {
      return;
    }
    const data = this.formComponent.form.value;
    return this.brandInfoService.put(this.brandService.getBrand(), data);
  }
}
